import { css, styled } from 'styled-components';
import Col from 'react-bootstrap/esm/Col';
import Container from 'react-bootstrap/esm/Container';
import { StyledColProps } from './types';
import Background from '../../../assets/background-tv.jpg';

const ovenPlayerStyle = `
  .op-watermark-container {

    .op-watermark {
      background-color: #000;
      padding: 1rem;
      display: flex;
      flex-direction: row;
      align-items: center;
      column-gap: 1rem;

      .op-watermark-text {
        display: flex;
        flex-direction: row;
        align-items: center;
        column-gap: 1rem;
      }

      .live {
        background-color: red;
        border-radius: 1rem;
        color: white;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        text-transform: uppercase;
        font-size: 0.75em;
        font-weight: bold;
        line-height: 1;
        padding: 0.25rem 0.75rem;

        &:before {
          background-color: white;
          content: '';
          display: inline-block;
          width: 0.6em;
          height: 0.6em;
          border-radius: 50%;
          margin-right: 0.5em;
          animation: blink 3s infinite;
          vertical-align: middle;
        }
      }

      .wall-name {
        height: 1rem;
      }
    }
  }
`;

const StyledCol = styled(Col).withConfig({
  shouldForwardProp: (prop) => !['visibility'].includes(prop),
})<StyledColProps>`
  ${(props) => css`
    visibility: ${props.visibility};
  `}
`;

const Wrapper = styled(Container)`
  width: 100%;
  height: 100%;
  min-height: 100vh;
  background-image: url(${Background});
  background-position: center center;
  background-size: cover;
  background-repeat: no-repeat;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 2rem 0 0rem;

  .bg-dark {
    background-color: #000 !important;
  }
`;

export { ovenPlayerStyle, StyledCol, Wrapper };
